import axios from "axios";
import { normalizeAxiosError } from "./axios.error";
const getApiUrl = () => {
    const envUrl = import.meta.env?.VITE_API_URL || process.env.VITE_API_URL;
    if (envUrl) {
        return envUrl;
    }
    // Default development backend port
    return "http://localhost:8080/api";
};
let baseURL = getApiUrl();
export const setPublicBaseURL = (url) => {
    baseURL = url;
    publicApi.defaults.baseURL = url;
};
export const publicApi = axios.create({
    baseURL,
    withCredentials: true,
});
publicApi.interceptors.response.use((res) => res, (err) => Promise.reject(normalizeAxiosError(err)));
